module.exports = __webpack_public_path__ + "img/gal-01.6841f1d4.png";